module.exports = __webpack_public_path__ + "static/media/dogs.51916a37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/dogs.svg
// module id = 540
// module chunks = 0